var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-group"},[_c('el-form-item',{attrs:{"label":"Placeholder"}},[_c('el-input',{model:{value:(_vm.field.placeholder),callback:function ($$v) {_vm.$set(_vm.field, "placeholder", $$v)},expression:"field.placeholder"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }